import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
  },
  loadingContainer: {
    height: 150,
    width: '100%',
  },
  button: {
    fontSize: theme.typography.pxToRem(13),
    textTransform: 'capitalize',
  },
  timezone: {
    color: theme.palette.secondary.light,
    fontSize: theme.typography.pxToRem(13),
  },
  time: {
    '& span p': {
      color: theme.palette.primary.main,
      fontSize: 11,
    },
  },
}));

const statusStyles = makeStyles((theme) => ({
  PAID: {
    color: theme.palette.statuses.paid,
  },
  PARTIAL: {
    color: theme.palette.error.main,
  },
  UNPAID: {
    color: theme.palette.error.main,
  },
  VOID: {
    color: theme.palette.error.main,
  },
  REQUESTED: {
    color: theme.palette.error.main,
  },
  REJECTED: {
    color: theme.palette.error.main,
  },
  CANREQUESTED: {
    color: theme.palette.error.main,
  },
  ACTIVE: {
    color: theme.palette.statuses.paid,
  },
  ONHOLD: {
    color: theme.palette.error.main,
  },
  CANCELLED: {
    color: theme.palette.error.main,
  },
  OVERPAID: {
    color: theme.palette.error.main,
  },
}));

export { useStyles, statusStyles };
